import { render, staticRenderFns } from "./DrawingControls.vue?vue&type=template&id=2b1fe933"
import script from "./DrawingControls.vue?vue&type=script&lang=js"
export * from "./DrawingControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports